import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import MaterialForm from "./MaterialForm";
import { addMaterial } from "../../../api/materialService";
import { getErrorMessage } from "../../../utils/errorHandler"

export default function AddMaterial() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [backendErrors, setBackendErrors] = useState({});

 const handleSubmit = async (formData) => {
  try {
    setLoading(true);

    const response = await addMaterial(formData);

    setMessage(response?.message || "Material added successfully");
if (response?.success === false || response?.status === 422) {
        setBackendErrors(response?.error || {});
        return;
      }
    setTimeout(() => {
      navigate("/material");
    }, 1500);
  } catch (error) {
    console.error(error);
    setMessage(getErrorMessage(error));
  } finally {
    setLoading(false);
  }
};

  return (
    <div className="container-fluid p-4">
      <div className="card p-4">
        
         {message && (
      <div
        className={`alert ${
          message.toLowerCase().includes("success")
            ? "alert-danger"
            : "alert-success"
        }`}
      >
        {message}
      </div>
    )}

        <MaterialForm
          onSubmit={handleSubmit}
          loading={loading}
          backendErrors={backendErrors}
          buttonText="Add Material"
        />
      </div>
    </div>
  );
}
